import React, { Component } from "react";
import {
  Row,
  Alert,
  Col,
  UncontrolledAlert,
  Card,
  Button,
  CardHeader,
  CardBody
} from "reactstrap";
import { MdAdd } from "react-icons/md";
import Formsy from "formsy-react";
import { Spinner } from "../../Shared";
import { TextInput } from "../../Shared/Forms";

class DealCategoryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false
    };
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  handleSubmit = data => {
    this.props.submitAction(data);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitted) {
      this.resetForm();
    }
  }

  resetForm = () => {
    this.refs.dealsCategoryForm.reset();
  };

  reset = () => {
    this.props.reset();
    this.resetForm();
  };

  render() {
    const { canSubmit } = this.state;
    const {
      submitting,
      error,
      hasParams,
      selectedRow,
      isView,
      fetchingRow,
      fetchingError
    } = this.props;

    return (
      <div>
        <Row>
          <Col>
            <Card>
              <CardHeader>
                {hasParams ? "Edit" : "Create"} Deals Category
              </CardHeader>
              <CardBody>
                {error && !error.errors ? (
                  <UncontrolledAlert color="danger">
                    {error.message}
                  </UncontrolledAlert>
                ) : null}
                {error && error.errors && error.errors.length ? (
                  <UncontrolledAlert color="danger">
                    {error.errors.map((error, index) => (
                      <p key={index}>{error.message}</p>
                    ))}
                  </UncontrolledAlert>
                ) : null}
                {fetchingError ? (
                  <UncontrolledAlert color="danger">
                    {fetchingError.message}
                  </UncontrolledAlert>
                ) : null}

                {fetchingRow && (
                  <Alert color="info">
                    <Spinner message="Fetching Deal Category" />
                  </Alert>
                )}
                <Formsy
                  ref="dealsCategoryForm"
                  onValidSubmit={this.handleSubmit}
                  onValid={this.enableButton}
                  onInvalid={this.disableButton}
                  noValidate
                >
                  <TextInput
                    name="name"
                    value={selectedRow && hasParams ? selectedRow.name : null}
                    required
                    disabled={submitting || isView || fetchingRow}
                    title="Name"
                    validations={{
                      minLength: 3,
                      maxLength: 50
                    }}
                    validationErrors={{
                      minLength: "Minimum of 3 characters allowed",
                      maxLength: "Maximum of 50 characters allowed"
                    }}
                  />

                  <TextInput
                    name="description"
                    type="textarea"
                    required
                    value={
                      hasParams && selectedRow ? selectedRow.description : null
                    }
                    disabled={submitting || isView || fetchingRow}
                    title="Description"
                    validations={{
                      minLength: 5
                    }}
                    validationErrors={{
                      minLength: "Minimum of 5 characters allowed",
                      maxLength: "Maximum of 50 characters allowed"
                    }}
                  />

                  {!isView ? (
                    <Button
                      type="submit"
                      color="primary"
                      disabled={!canSubmit || submitting || isView}
                      className="pp3"
                    >
                      {submitting ? (
                        <Spinner size="sm" />
                      ) : (
                        <span>
                          {hasParams ? "Update" : "Create"} <MdAdd size={20} />
                        </span>
                      )}
                    </Button>
                  ) : null} {" "}
                  {hasParams ? (
                    <Button
                      type="button"
                      outline
                      color="primary"
                      onClick={() => this.reset()}
                      className="mr-1"
                    >
                      Reset
                    </Button>
                  ) : null}
                </Formsy>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default DealCategoryForm;
